module.exports = __webpack_public_path__ + "img/mobile.dbb43ff6.svg";